import React, { ComponentType } from 'react';
import Modal, { ModalProps } from 'antd/lib/modal';

type WithModalProps = Pick<ModalProps, 'visible' | 'onCancel'>;

const withModal = (modalProps?: ModalProps) => <P extends object>(
  Component: ComponentType<P>
) => {
  const WithModal = (props: P & WithModalProps) => {
    const { visible, onCancel, ...otherProps } = props;
    return (
      <Modal open={visible} onCancel={onCancel} {...modalProps}>
        <Component {...(otherProps as P)} />
      </Modal>
    );
  };

  return WithModal;
};

export default withModal;
